"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createConsultations = createConsultations;
const shared_1 = require("../../shared");
const queries_1 = require("../queries");
const createLiverElastography_1 = require("./createLiverElastography");
const createPulmonaryFunctionTest_1 = require("./createPulmonaryFunctionTest");
const messages_1 = require("./messages");
const messages = {
    consultations: {
        id: "dashboard.consultations",
        defaultMessage: "Konzíliumok"
    },
    urology: {
        id: "dashboard.urology",
        defaultMessage: "Urológia"
    },
    gynecology: {
        id: "dashboard.gynecology",
        defaultMessage: "Nőgyógyászat"
    },
    ophthalmologicExamination: {
        id: "dashboard.ophthalmologic_examination",
        defaultMessage: "Szemészet"
    },
    earNoseThroat: {
        id: "dashboard.ear_nose_throat",
        defaultMessage: "Fül-orr-gégészet"
    },
    dentalScreening: {
        id: "dashboard.dental_screening",
        defaultMessage: "Fogászat"
    },
    neurology: {
        id: "dashboard.neurology",
        defaultMessage: "Neurológia"
    },
    addictionAssessment: {
        id: "dashboard.addiction_assessment",
        defaultMessage: "Addiktológia"
    },
    psychiatricAssessment: {
        id: "dashboard.psychiatric_assessment",
        defaultMessage: "Pszichiátria"
    },
    psychologicalAssessment: {
        id: "dashboard.psychological_assessment",
        defaultMessage: "Pszichológia"
    },
    anesthesiology: {
        id: "dashboard.anesthesiology",
        defaultMessage: "Aneszteziológia"
    },
    ercp: {
        id: "dashboard.ercp",
        defaultMessage: "ERCP"
    },
    mrcp: {
        id: "dashboard.mrcp",
        defaultMessage: "MRCP"
    },
    liverBiopsy: {
        id: "dashboard.liver_biopsy",
        defaultMessage: "Májbiopszia"
    },
    boneScan: {
        id: "dashboard.bone_scan",
        defaultMessage: "Csontizotóp"
    },
    oncology: {
        id: "dashboard.oncology",
        defaultMessage: "Onkológia"
    },
    otherConsultations: {
        id: "dashboard.other_consultations",
        defaultMessage: "Egyéb konzílium"
    },
    colitisUlcerosa: {
        id: "dashboard.colitis_ulcerosa",
        defaultMessage: "Colitis ulcerosa"
    },
    crohnDisease: {
        id: "dashboard.crohn_disease",
        defaultMessage: "Crohn-betegség"
    },
    contraindication: {
        id: "dashboard.contraindication",
        defaultMessage: "Kontraindikáció"
    },
    noContraindication: {
        id: "dashboard.no_contraindication",
        defaultMessage: "Nincs kontraindikáció"
    }
};
var ConsultationResult;
(function (ConsultationResult) {
    ConsultationResult["NORMAL"] = "NORMAL";
    ConsultationResult["ABNORMAL"] = "ABNORMAL";
})(ConsultationResult || (ConsultationResult = {}));
var ContraindicationResult;
(function (ContraindicationResult) {
    ContraindicationResult["PRESENT"] = "PRESENT";
    ContraindicationResult["NONE"] = "NONE";
})(ContraindicationResult || (ContraindicationResult = {}));
const groups = [
    {
        label: messages_1.messages.abnormal,
        variant: "dark",
        predicate: (event) => event !== undefined && event.value === ConsultationResult.ABNORMAL
    },
    {
        label: messages_1.messages.normal,
        variant: "light",
        predicate: (event) => event !== undefined && event.value === ConsultationResult.NORMAL
    }
];
const contraindicationGroups = [
    {
        label: messages.contraindication,
        variant: "dark",
        predicate: (event) => event !== undefined &&
            event.value === ContraindicationResult.PRESENT
    },
    {
        label: messages.noContraindication,
        variant: "light",
        predicate: (event) => event !== undefined && event.value === ContraindicationResult.NONE
    }
];
const values = [
    {
        label: messages.urology,
        query: queries_1.queries.urology
    },
    {
        label: messages.gynecology,
        query: queries_1.queries.gynecology
    },
    {
        label: messages.ophthalmologicExamination,
        query: queries_1.queries.ophthalmologicExamination
    },
    {
        label: messages.earNoseThroat,
        query: queries_1.queries.earNoseThroat
    },
    {
        label: messages.dentalScreening,
        query: queries_1.queries.dentalScreening
    },
    {
        label: messages.neurology,
        query: queries_1.queries.neurology
    },
    {
        label: messages.psychologicalAssessment,
        query: queries_1.queries.psychologicalAssessment
    },
    {
        label: messages.ercp,
        query: queries_1.queries.ercp
    },
    {
        label: messages.mrcp,
        query: queries_1.queries.mrcp
    },
    {
        label: messages.liverBiopsy,
        query: queries_1.queries.liverBiopsy
    },
    {
        label: messages.boneScan,
        query: queries_1.queries.boneScan
    },
    {
        label: messages.oncology,
        query: queries_1.queries.oncology
    },
    {
        label: messages.otherConsultations,
        query: queries_1.queries.otherConsultations
    },
    {
        label: messages.colitisUlcerosa,
        query: queries_1.queries.colitisUlcerosa
    },
    {
        label: messages.crohnDisease,
        query: queries_1.queries.crohnDisease
    },
    {
        label: messages.anesthesiology,
        query: queries_1.queries.anesthesiology
    }
];
const contraindicationValues = [
    {
        label: messages.addictionAssessment,
        query: queries_1.queries.addictionAssessment
    },
    {
        label: messages.psychiatricAssessment,
        query: queries_1.queries.psychiatricAssessment
    }
];
function createConsultations(intl, options) {
    const { events } = options;
    const list = (0, shared_1.createGroupList)(intl, { events, groups, values });
    const contraindicationList = (0, shared_1.createGroupList)(intl, {
        events,
        groups: contraindicationGroups,
        values: contraindicationValues
    });
    const liverElastography = (0, createLiverElastography_1.createLiverElastography)(intl, options);
    const pulmonaryFunctionTest = (0, createPulmonaryFunctionTest_1.createPulmonaryFunctionTest)(intl, options);
    const content = (0, shared_1.createSectionContent)([
        list,
        contraindicationList,
        liverElastography,
        pulmonaryFunctionTest
    ]);
    return (0, shared_1.createSection)(intl, {
        label: messages.consultations,
        content
    });
}
